"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Box2 = _interopRequireDefault(require("@mui/material/Box"));
var _Divider2 = _interopRequireDefault(require("@mui/material/Divider"));
var _react = _interopRequireDefault(require("react"));
var _challengeLeaderboard = require("../../challenge-leaderboard");
var _item = _interopRequireDefault(require("./item"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function FakeEmployees({
  FakeItemsCard,
  event,
  freeOfferEmployeesLeaderboardsMaxRowsCount
}) {
  return /*#__PURE__*/_react.default.createElement(_Box2.default, {
    sx: {
      position: 'relative'
    }
  }, _challengeLeaderboard.fakeEmployees.map((user, index) => {
    const rank = freeOfferEmployeesLeaderboardsMaxRowsCount + 2;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: index
    }, /*#__PURE__*/_react.default.createElement(_Divider2.default, {
      sx: {
        borderColor: '#dde0e7'
      }
    }), /*#__PURE__*/_react.default.createElement(_item.default, {
      blurred: true,
      challengeType: event.challengeTemplate?.type,
      item: {
        user,
        rank,
        leaderboardIndex: rank + index,
        progressValue: 0
      },
      prevItemRank: freeOfferEmployeesLeaderboardsMaxRowsCount + 1
    }));
  }), /*#__PURE__*/_react.default.createElement(FakeItemsCard, {
    isEventWithOffer: true
  }));
}
var _default = exports.default = FakeEmployees;